module.exports = __webpack_public_path__ + "static/media/smartphone.27a91d8c.png";